import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { UserDataType } from "../../types/dataTypes";
import { MAX_COUNT } from "../../utils/whatsAppUtils";

const initialState: UserDataType = {
  recruiterId: "",
  channelId: "",
  corpId: "",
  subChannelId: "",
  username: "",
  trackingId: "",
  siteContext: "",
  campaignMaxLimit: `${MAX_COUNT || 5000}`
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser(state, action: PayloadAction<{ userData: UserDataType }>) {
      const {
        channelId,
        corpId,
        recruiterId,
        subChannelId,
        username,
        siteContext
      } = action.payload.userData;
      state.channelId = channelId;
      state.corpId = corpId;
      state.recruiterId = recruiterId;
      state.subChannelId = subChannelId;
      state.username = username;
      state.siteContext = siteContext
    },
    setCampaignMaxLimit(state, action: PayloadAction<{ campaignMaxLimit: string }>) {
      const { campaignMaxLimit } = action.payload;
      state.campaignMaxLimit = campaignMaxLimit;
    }
  },
});

const userReducer = userSlice.reducer;
const userActions = userSlice.actions;

export { userActions };
export default userReducer;
